import { css, type Theme } from "@emotion/react";
import styled from "@emotion/styled";

import { FONT_WEIGHT_SEMI_BOLD } from "@skilitics/designer-ui-components";

import { DROPZONE_PADDING } from "./constants";

const zoneHeaderHeight = 24;

const dropzoneCss = ({ theme }: { theme: Theme }) => css`
  background: ${theme.scrimLight};

  padding: ${DROPZONE_PADDING}px;
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
`;

export const ROOT_CONDITION_CLASSNAME = "root-condition";
export const ConditionsListContainer = styled.div`
  ${dropzoneCss};
  padding: 0;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
  &.${ROOT_CONDITION_CLASSNAME} {
    padding-bottom: ${DROPZONE_PADDING}px;
  }
`;

export const ConditionPlaceholderDropzone = styled.div`
  ${dropzoneCss};

  color: ${({ theme }) => theme.generalTextIconVariant};
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
  height: 100%;
  text-align: center;
`;

export const EffectsPlaceholderDropzone = styled.div`
  ${dropzoneCss};

  height: 100%;
  color: ${({ theme }) => theme.generalTextIconVariant};
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
  text-align: center;
`;

export const EffectsListContainer = styled.div`
  ${dropzoneCss};
  padding-left: 0;
  padding-top: 0;
  height: 100%;
  justify-content: flex-start;
`;

export const ResponseZoneHeader = styled.div`
  min-height: ${zoneHeaderHeight}px;
  font-size: ${({ theme }) => theme.fontSize};
  text-align: left;
  padding-bottom: 6px;
  margin: 0 ${DROPZONE_PADDING}px;
  border-bottom: solid 1px ${({ theme }) => theme.generalTextIcon};
  display: inline-block;
`;

export const ResponseZoneContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  ${ResponseZoneHeader} {
    flex: 0 0 auto;
  }
`;

export const EditButtonContainer = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  padding: 0;

  opacity: 0;
  transition: opacity 0.2s ease-in-out;
`;

export const ConditionOrEffectIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  border-radius: 5px;
  background: ${({ theme }) => theme.surface};
  border: solid 1px ${({ theme }) => theme.outlineSoft};
`;
